const typographyTimeActions = {
  timelineTitle: 'Timeline',
  adminWarning: 'Los administradores pueden editar la información, agregar archivos, comentarios y completar/cancelar acciones',
  analystWarning: 'Los analistas pueden agregar archivos, comentarios y completar/cancelar en cualquier acciones, y editar la información de las acciones que crearon',
  contractorWarning: 'Las contratistas pueden agregar archivos, comentarios y completar/cancelar las acciones de las que son responsables'

};

export default typographyTimeActions;
